import jbAPI from "./jobboard";

export const getApplicantsByCompany = async (company_id, token) => {
  try {
    const response = await jbAPI.get(
      `/employer/applicants?company_id=${company_id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    console.log(response.data);
    return response.data; // grouped applicants + jobs
  } catch (error) {
    console.error("Failed to fetch applicants:", error);
    return [];
  }
};

export const getApplicantJobs = async (company_id, seeker_id, token) => {
  try {
    const response = await jbAPI.get(
      `/employer/applicants/jobs?company_id=${company_id}&seeker_id=${seeker_id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Failed to fetch applicant jobs:", error);
    return null;
  }
};